import { apiClient } from "../axiosConfig";

export interface DialpadOpeningHours {
  hoursEnabled: boolean;
  timezone: string;
  mondayHours: string[];
  tuesdayHours: string[];
  wednesdayHours: string[];
  thursdayHours: string[];
  fridayHours: string[];
  saturdayHours: string[];
  sundayHours: string[];
}

export interface DialpadAvailabilityResponse {
  available: boolean;
  status: string;
  availabilityCheckFailed: boolean;
  openingHours: DialpadOpeningHours;
}

export interface DialpadRequestCallbackRequest {
  enquiryId: string;
}

export interface DialpadRequestCallbackResponse {
  success: boolean;
  position: number;
}

export interface DialpadAvailabilityParams {
  journeyId?: string;
  journeyVersion?: string;
}

export const dialpadApi = {
  getAvailability: async (
    params?: DialpadAvailabilityParams
  ): Promise<DialpadAvailabilityResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.journeyId) searchParams.set("journeyId", params.journeyId);
    if (params?.journeyVersion) searchParams.set("journeyVersion", params.journeyVersion);
    const query = searchParams.toString();
    const url = query ? `/api/dialpad/availability?${query}` : "/api/dialpad/availability";
    const response = await apiClient.get<DialpadAvailabilityResponse>(url);
    return response.data;
  },

  requestCallback: async (
    request: DialpadRequestCallbackRequest
  ): Promise<DialpadRequestCallbackResponse> => {
    const response = await apiClient.post<DialpadRequestCallbackResponse>(
      "/api/dialpad/request-callback",
      request
    );
    return response.data;
  },
};
